import { MeasureController } from "../../MeasureController";
import { JudgmentResult, JudgmentResultType } from "../../types.client";
import { ChargingVoltageMeasure } from "../../../models/schemas/measures/electrical.schema";
import { CHARGING_VOLTAGE_THRESHOLDS } from "../../constants/judgmentCriteria";

/**
 * 충전전압/전류 컨트롤러
 * 판정 기준:
 * - 전압: CHARGING_VOLTAGE_THRESHOLDS.voltage (13.4~13.6V)
 * - 전류: <= CHARGING_VOLTAGE_THRESHOLDS.current.max (0.1A)
 * - 둘 다 만족: GOOD, 하나라도 불만족: BAD
 */
export class ChargingVoltageController extends MeasureController<ChargingVoltageMeasure> {
  protected getDefaultData(): ChargingVoltageMeasure {
    return {
      chargingVoltage: 0,
      chargingCurrent: 0,
      result: null,
      discussion: "",
      remark: "",
      photo: { checkUrl: "", resultUrl: "" },
    };
  }

  protected judge(): JudgmentResult {
    const { chargingVoltage, chargingCurrent } = this.data;

    // 데이터 미입력 시
    if (!chargingVoltage || chargingCurrent === undefined || chargingCurrent === null) {
      return {
        result: "NA",
        discussion: this.generateDiscussion("NA"),
      };
    }

    // 판정: 전압 범위 AND 전류 <= max
    const { voltage, current } = CHARGING_VOLTAGE_THRESHOLDS;
    const voltageOk = chargingVoltage >= voltage.min && chargingVoltage <= voltage.max;
    const currentOk = chargingCurrent <= current.max;
    const result: JudgmentResultType = voltageOk && currentOk ? "GOOD" : "BAD";

    return {
      result,
      discussion: this.generateDiscussion(result),
    };
  }

  protected generateDiscussion(result: JudgmentResultType): string {
    if (result === "NA") {
      return "데이터 미입력";
    }
    if (result === "GOOD") {
      return "충전전압(13.4~13.6V) 및 충전전류(≤0.1A) 정상";
    }
    return "충전전압 또는 충전전류가 기준 범위를 벗어남. 점검 필요";
  }
}
